import { render, staticRenderFns } from "./PushNotificationShow.vue?vue&type=template&id=0dc7def1&"
import script from "./PushNotificationShow.vue?vue&type=script&lang=js&"
export * from "./PushNotificationShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports